module.exports = __webpack_public_path__ + "img/instagram.b822c2e2.png";